export default __webpack_public_path__ + "static/media/img-table-30anos-mobile.42a9d2a9.png";